import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SystemInterface } from 'app/models/system.model';
import { RequestService } from 'app/modules/common/utils/request.service';
import { Observable } from 'rxjs';
import { SystemDataTransformPost } from './data-transforms/system.data.transform.post';
import { SystemDataTransformGet } from './data-transforms/system.data.transform.get';

@Injectable({
  providedIn: 'root',
})
export class SystemHttpInterceptor implements HttpInterceptor {
  private readonly _rexp = new RegExp(/^\/systems(\/[0-9a-z]{24}(\/content)?)?$/);

  constructor(
    private readonly _transformUp: SystemDataTransformGet,
    private readonly _transformDown: SystemDataTransformPost,
  ) {}

  intercept(req: HttpRequest<SystemInterface>, next: HttpHandler): Observable<HttpEvent<SystemInterface>> {
    return RequestService.getTransformedHttpEvent<SystemInterface>(
      req,
      next,
      this._rexp,
      this._transformDown,
      this._transformUp,
    );
  }
}
